import { HTMLExtUtils } from '@ssml-editor/core';
import { PHONEME_TYPE } from './constant.js';

const phonemeElementToHtml = ({
  element,
  childrenHtml
}) => {
  const { mark, alphabet, ph } = element;
  return HTMLExtUtils.createElementAsString(
    PHONEME_TYPE,
    true,
    false,
    {
      mark,
      alphabet,
      ph
    },
    childrenHtml
  );
};

export { phonemeElementToHtml };
//# sourceMappingURL=element-to-html.js.map
